// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29G-j","label":"styles_label__3Bgc5"};